import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import Loader from './components/common/Loader';
import './App.css';

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loader size="large" fullScreen />;
  }

  return user ? <Dashboard /> : <Login />;
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;